import React, { useEffect, useState, useRef } from 'react';
import { Button, Stack, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PaperCard } from 'components/Card';
import { Error } from './Error';
import { paths } from 'routes';
import { useAuth } from 'lib/auth';
import { Loader } from 'components/Loader';

export const EmailSentForm = ({ values, error, setError }) => {
  const { t } = useTranslation();
  const { signup } = useAuth();
  const [ loading, setLoading ] = useState(true);
  const initialLoad = useRef(true);
  useEffect(() => {
    const createUser = async () => {
      try {
        await signup({
          ...values,
          'cf-turnstile-response': values.turnstileToken, // Added
        });
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }    };

    if (initialLoad.current) {
      initialLoad.current = false;
      createUser();
    }
  }, []);

  return (
    <>
      {loading && (
        <Box height={233} sx={{alignContent: "center", mb: 5}}>
          <Loader />
        </Box>
      )}
      {!loading && (
        <>
        {error && (
          <Error />
        )}
        {!error && (
          <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 368 }} maxWidth={{ sm: 368 }} sx={{ mb: 5 }}>
            <Stack>
              <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
                {t('website:auth.confirmationSent.heading')}
              </Typography>
              <Stack sx={{ textAlign: 'center' }}>
                <Typography variant="body1">{t('website:auth.register.emailSentBuyers.adminEmailSent')}</Typography>
                <Typography variant="body1">{t('website:auth.register.emailSentBuyers.contactSoon')}</Typography>
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  sx={{
                    mt: 2,
                    mb: 0.5,
                    bgcolor: "primary.light",
                    '&:hover': {
                      backgroundColor: "primary.light",
                    },
                  }}
                  href={paths.homepage}
                >
                  {t('website:auth.confirmationSent.returnToHomeButton')}
                </Button>
              </Stack>
            </Stack>
          </PaperCard>
        )}
        </>
      )}
    </>
  );
};
